import f from './functions.js'


var Media = function () {
	var self = this;

	self.gettingmedia = false;
	var audioContext = null

	var permissions = {
		ios: {
			audio: function () {
				return new Promise((resolve, reject) => {

					window.AudioToggle.checkAudioPermission(function(hasPermission){
						if (hasPermission) {
							resolve();
						} else {
							reject("permissions");
						}
					})

				});
			},

			video: function () {
				return new Promise((resolve, reject) => {

					window.AudioToggle.checkVideoPermission(function(hasPermission){
						if (hasPermission) {

							window.AudioToggle.checkAudioPermission(function(hasPermission){
								if (hasPermission) {
									resolve();
								} else {
									reject("permissions");
								}
							})

						} else {
							reject("permissions");
						}
					})

				});
			},
		},

		audio: function () {
			var permissions = window.cordova.plugins.permissions;

			return new Promise((resolve, reject) => {
				if (permissions) {
					var request = function () {
						permissions.requestPermission(
							permissions.RECORD_AUDIO,
							(status) => {
								if (status.hasPermission) {
									resolve();
								} else {
									reject("permissions");
								}
							},
							(err) => {
								console.error(err);

								reject("permissions");
							}
						);
					};

					permissions.checkPermission(
						permissions.RECORD_AUDIO,
						(status) => {
							if (status.hasPermission) {
								resolve();
							} else {
								request();
							}
						},
						(err) => {
							console.error(err);

							request();
						}
					);
				} else {
					reject("permissions");
				}
			});
		},

		video: function () {
			var permissions = window.cordova.plugins.permissions;

			return new Promise((resolve, reject) => {
				if (permissions) {
					permissions.hasPermission(permissions.CAMERA, (status) => {
						if (status.hasPermission) {
							resolve();
						} else {
							permissions.requestPermission(
								permissions.CAMERA,
								() => {
									resolve();
								},
								() => {
									reject("permissions");
								}
							);
						}
					});
				} else {
					reject("permissions");
				}
			});
		},
	};

	var initPermissions = function (mediasettings) {
		var callperm = function (f, setting) {
			if (setting) {
				return f();
			} else {
				return Promise.resolve();
			}
		};

		if (window.cordova && window.device) {
			var ios = f.isios();

			return callperm(
				ios ? permissions.ios.audio : permissions.audio,
				mediasettings.audio
			)
				.then(() => {
					return callperm(
						ios ? permissions.ios.video : permissions.video,
						mediasettings.video
					);
				})
				.catch((e) => {
					console.error("E", e);
					return Promise.reject(e);
				});
		}

		return Promise.resolve();
	};

	var initMedia = function (mediasettings) {
		return new Promise((resolve, reject) => {
			initPermissions(mediasettings)
				.then(() => {
					if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
						navigator.mediaDevices
							.getUserMedia(mediasettings)
							.then(resolve)
							.catch(reject);
					} else {
						(
							navigator.getUserMedia ||
							navigator.webkitGetUserMedia ||
							navigator.mozGetUserMedia ||
							navigator.msGetUserMedia
						)(mediasettings, resolve, reject);
					}
				})
				.catch(reject);
		});
	};

	self.get = function (mediasettings) {
		return initMedia(mediasettings);
	};

	self.getAudioContext = function(){
		if(audioContext) {

			console.log('audioContext.state', audioContext.state)

			if (audioContext.state === 'suspended') {
				audioContext.resume();
			}

			return audioContext
		}

		audioContext = new (window.AudioContext || window.webkitAudioContext)();

		return audioContext
	}

	self.permissions = initPermissions;
};

export default Media
